
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexbKYXyHWYaD4LsC5IWoCl9FYOZewJkO7PVitWlclKvIoMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/index.vue?macro=true";
import { default as loginx92u21c6ixQDBxjU2ObWxXzU5crgAweic8O2mqeA_YcMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/login.vue?macro=true";
import { default as contactEUG7bhGqKWr0cpfTqOt0zGOesnyS9MavmQVBpB0cQccMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/contact.vue?macro=true";
import { default as teamC73IkQOUc2Do9MUsN987ngMrtHPXoRJrHeSmrjPibpYMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/about/team.vue?macro=true";
import { default as indexfbjK_b6XURNoJYQ8rQDvMuvbJr48SSpNpji3UAJ6KiYMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/about/index.vue?macro=true";
import { default as indexfwHpaWde3hcFyfuVwti5cGSJVRB3zC6F_RP8E4L2mzEMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/index.vue?macro=true";
import { default as privacy_45policyKnd9VNiDCh62xflC81UpWXTtaBy2u_cqr5PWN1FGs_45sMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/privacy-policy.vue?macro=true";
import { default as holidaycmfeft4hkgP7EvL4QtVOr6im9EweKvaeeJZVrlSnTIcMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/holiday.vue?macro=true";
import { default as adminjBspK50UEjw_JoEq0GlI_45LgW8jLi3aFjn1XbAav2zTYMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/scientists/admin.vue?macro=true";
import { default as indexCrU2gZUrMPCTuEky6DeFx6_C5OPcqR_4511HI_45xJW7lNUMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/scientists/index.vue?macro=true";
import { default as treatmenttskykuI_lqVjkYjzgah_450VhUTGwplQw0aEXCSk_jclwMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/treatment.vue?macro=true";
import { default as prevention_mPTS252m8cDWxjEGTX2VTgUFcUo818b7AWixgw7Pd8Meta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/prevention.vue?macro=true";
import { default as _91id_93_45CcLEyY1BnBDjNkV8GvVpckPqnAW2Ptvn32_45AOSO0oEMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/scientists/news/[id].vue?macro=true";
import { default as prescriptionUL0bB9Cmom0AZQQZ6EQJW9z0PZDARhNr7rKawq_452t4IMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/prescription.vue?macro=true";
import { default as clinicians6C5kHEY3z_WRmNmAANhTa4ABbx__45gNORagfW6zcNibIMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/scientists/clinicians.vue?macro=true";
import { default as scientistsI67uVRDV4W_7O6p5WjkfY__yiFzyfW_45GWbZpJ2Ns5P8Meta } from "/home/wann/Development/vuenuxt/ordinator/pages/scientists/scientists.vue?macro=true";
import { default as womans_45health2CptBJ9ka_GQp9sgpsX439Gi27ial2kCDy2nQ24mdVoMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/womans-health.vue?macro=true";
import { default as indexQPFzpO945ZhGu_45rP4nHISccp_45s_KzvpVKPTk4swPHEIMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/packages/index.vue?macro=true";
import { default as indexiGzLi4lnEv0tEZrGbSVGNWM9fMbl_tr7FFmPNTPN3D8Meta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/packages/[id]/index.vue?macro=true";
import { default as index5hmpS_OPny8jkfEYb4GfCFT3VDfqL09T85YUdNeBy9kMeta } from "/home/wann/Development/vuenuxt/ordinator/pages/patients/virtual-clinic/index.vue?macro=true";
import { default as component_45stubCezZ5iYsEEYunM_45mf8kKdBpzpWmEqjIOSVC7haP_ajUMeta } from "/home/wann/Development/vuenuxt/ordinator/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubCezZ5iYsEEYunM_45mf8kKdBpzpWmEqjIOSVC7haP_ajU } from "/home/wann/Development/vuenuxt/ordinator/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/index.vue")
  },
  {
    name: "index___no",
    path: "/",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/login.vue")
  },
  {
    name: "login___no",
    path: "/login",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/login.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/contact.vue")
  },
  {
    name: "contact___no",
    path: "/contact",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/contact.vue")
  },
  {
    name: "about-team___en",
    path: "/en/about/team",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/about/team.vue")
  },
  {
    name: "about-team___no",
    path: "/about/team",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/about/team.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/about/index.vue")
  },
  {
    name: "about___no",
    path: "/about",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/about/index.vue")
  },
  {
    name: "patients___en",
    path: "/en/patients",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/index.vue")
  },
  {
    name: "patients___no",
    path: "/patients",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___no",
    path: "/privacy-policy",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/privacy-policy.vue")
  },
  {
    name: "patients-holiday___en",
    path: "/en/patients/holiday",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/holiday.vue")
  },
  {
    name: "patients-holiday___no",
    path: "/patients/holiday",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/holiday.vue")
  },
  {
    name: "scientists-admin___en",
    path: "/en/scientists/admin",
    meta: {"middleware":"auth"},
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/admin.vue")
  },
  {
    name: "scientists-admin___no",
    path: "/scientists/admin",
    meta: {"middleware":"auth"},
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/admin.vue")
  },
  {
    name: "scientists___en",
    path: "/en/scientists",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/index.vue")
  },
  {
    name: "scientists___no",
    path: "/scientists",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/index.vue")
  },
  {
    name: "patients-treatment___en",
    path: "/en/patients/treatment",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/treatment.vue")
  },
  {
    name: "patients-treatment___no",
    path: "/patients/treatment",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/treatment.vue")
  },
  {
    name: "patients-prevention___en",
    path: "/en/patients/prevention",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/prevention.vue")
  },
  {
    name: "patients-prevention___no",
    path: "/patients/prevention",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/prevention.vue")
  },
  {
    name: "scientists-news-id___en",
    path: "/en/scientists/news/:id()",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/news/[id].vue")
  },
  {
    name: "scientists-news-id___no",
    path: "/scientists/news/:id()",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/news/[id].vue")
  },
  {
    name: "patients-prescription___en",
    path: "/en/patients/prescription",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/prescription.vue")
  },
  {
    name: "patients-prescription___no",
    path: "/patients/prescription",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/prescription.vue")
  },
  {
    name: "scientists-clinicians___en",
    path: "/en/scientists/clinicians",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/clinicians.vue")
  },
  {
    name: "scientists-clinicians___no",
    path: "/scientists/clinicians",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/clinicians.vue")
  },
  {
    name: "scientists-scientists___en",
    path: "/en/scientists/scientists",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/scientists.vue")
  },
  {
    name: "scientists-scientists___no",
    path: "/scientists/scientists",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/scientists/scientists.vue")
  },
  {
    name: "patients-womans-health___en",
    path: "/en/patients/womans-health",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/womans-health.vue")
  },
  {
    name: "patients-womans-health___no",
    path: "/patients/womans-health",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/womans-health.vue")
  },
  {
    name: "patients-packages___en",
    path: "/en/patients/packages",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/packages/index.vue")
  },
  {
    name: "patients-packages___no",
    path: "/patients/packages",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/packages/index.vue")
  },
  {
    name: "patients-packages-id___en",
    path: "/en/patients/packages/:id()",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/packages/[id]/index.vue")
  },
  {
    name: "patients-packages-id___no",
    path: "/patients/packages/:id()",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/packages/[id]/index.vue")
  },
  {
    name: "patients-virtual-clinic___en",
    path: "/en/patients/virtual-clinic",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/virtual-clinic/index.vue")
  },
  {
    name: "patients-virtual-clinic___no",
    path: "/patients/virtual-clinic",
    component: () => import("/home/wann/Development/vuenuxt/ordinator/pages/patients/virtual-clinic/index.vue")
  },
  {
    name: component_45stubCezZ5iYsEEYunM_45mf8kKdBpzpWmEqjIOSVC7haP_ajUMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubCezZ5iYsEEYunM_45mf8kKdBpzpWmEqjIOSVC7haP_ajU
  },
  {
    name: component_45stubCezZ5iYsEEYunM_45mf8kKdBpzpWmEqjIOSVC7haP_ajUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubCezZ5iYsEEYunM_45mf8kKdBpzpWmEqjIOSVC7haP_ajU
  }
]